// extracted by mini-css-extract-plugin
module.exports = {"chip":"mkqnicnPkN1njdqYZSTL","chipFix":"uJINxZvdej_VhDLTQOR7","subIcon":"keTPX7QnYXbYH6aqoWBg"};